export default __webpack_public_path__ + "images/41ad7e89ecf53d0a51749baae3010555-valentines_groove_on.webp";